import { Result } from '@standardnotes/domain-core';
export class GetHost {
    constructor(legacyApi) {
        this.legacyApi = legacyApi;
    }
    execute() {
        return Result.ok(this.legacyApi.getHost());
    }
}
